var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cb8f55",
    d: "m244.2 43.8l-32-32a5.8 5.8 0 0 0-8.4 0a5.8 5.8 0 0 0 0 8.4l3.1 3.2l-57.4 43l-38.7 7.7a5.4 5.4 0 0 0-3 1.7l-84.7 84.6a22 22 0 0 0 0 31.2l41.3 41.3a22 22 0 0 0 31.2 0l84.6-84.7a5.4 5.4 0 0 0 1.7-3l7.7-38.7l43-57.4l3.2 3.1a5.9 5.9 0 1 0 8.4-8.4ZM104 207.5L48.5 152L96 104.5l55.5 55.5Zm-31.1 16.9l-41.3-41.3a9.9 9.9 0 0 1 0-14.2l8.4-8.4L95.5 216l-8.4 8.4a10.1 10.1 0 0 1-14.2 0Zm106.3-124a6.6 6.6 0 0 0-1.1 2.4l-7.6 38.2l-10.5 10.5L104.5 96L115 85.5l38.2-7.6a6.6 6.6 0 0 0 2.4-1.1l59.8-44.9l8.7 8.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeer);
export default __webpack_public_path__ + "static/media/beer.ca504f561c6727425538ac27d3a6f332.svg";
export { ForwardRef as ReactComponent };